import Payment from 'payment';

function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}

export function formatCreditCardNumber(value) {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case 'amex':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10,
      )} ${clearValue.slice(10, 15)}`;
      break;
    case 'dinersclub':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10,
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8,
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
}

export function formatReal(amount, tpCampo, installments) {
  const convertString = amount.toString();
  const reverterNumber = convertString.split("").reverse().join("");
  const caractereSparador = ".";
  const position = 2;
  const output = [reverterNumber.slice(0, position), caractereSparador, reverterNumber.slice(position)].join("");
  const resultado = output.split("").reverse().join("");
  const parcelas = parseFloat(resultado,10) / installments;
  const transformParcela = parcelas.toLocaleString('pt-BR', { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const transforAmount = 'R$ ' + resultado.toLocaleString('pt-BR', { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const valorAmount = transforAmount.replace('.', ',');
  const valorInstallments =  transformParcela.replace('.', ',');
 return  tpCampo === 'amount' ? valorAmount : valorInstallments;
}

export function formatCVC(value, prevValue, allValues = {}) {
  const clearValue = clearNumber(value);
  let maxLength = 4;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
    maxLength = issuer === 'amex' ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value) {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
}

export function formatFormData(data) {
  return Object.keys(data).map(d => `${d}: ${data[d]}`);
}


export function checkIfFieldsAreInvalid(card_data, address_data) {
  const nameInvalid = !card_data.name || !card_data.name.trim()
  const numberInvalid = !card_data.number || (card_data.length < 11 || card_data.length > 19)
  const expiryInvalid = !card_data.expiry
  const phoneInvalid = !address_data.phone_number
  const emailInvalid = !address_data.email
  const securityCodeInvalid = !card_data.cvc
  const addressInvalid = !address_data.street || !address_data.number_address || !address_data.neighborhood || !address_data.city || !address_data.state_code || !address_data.postal_code


  if (phoneInvalid || emailInvalid || nameInvalid || numberInvalid || expiryInvalid || securityCodeInvalid || addressInvalid) {
    return true
  }
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function formatRequiredStrings(expiry, number) {
  var expiry_mm = expiry.split('/')[0]
  var expiry_yy = expiry.split('/')[1]
  var number_without_spaces = number.replace(/\s/g, "");

  return { expiry_mm, expiry_yy, number_without_spaces }
}


export function assembleBodyRequest(formatedCardStrings, card_data, address_data, billing, ip_address, session_id) {
  let [nome, ...sobrenome] = card_data.name.split(' ')
  sobrenome = sobrenome.join(' ')

  const body = JSON.stringify(
      {
        "link_id": billing.id,
        "valor_pagamento": billing.amount,
        "captura_manual": false,
        "bypass_risco": false,
        "session_id": session_id,
        "ip_address": ip_address,
        "parcela": {
          "numero_parcelas": billing.installments,
          "valor_adiantamento": 0,
          "valor_parcela": billing.amount_per_installment
        },
        "cartao": {
          "numero":  formatedCardStrings.number_without_spaces,
          "expiracao": `${formatedCardStrings.expiry_mm}/${formatedCardStrings.expiry_yy}`,
          "codigo_seguranca": card_data.cvc,
          "bandeira": card_data.issuer
        },
        "portador_cartao": {
          "nome": nome,
          "sobrenome": sobrenome,
          "numero_telefone": address_data.phone_number,
          "tipo_phone": "HOME",
          "email": address_data.email,
          "tipo_documento": card_data.type_document,
          "documento": card_data.document_number.replace(/[^\d]+/g, '')
        },
        "endereco_cobranca": {
          "logradouro": `${address_data.street}, ${address_data.number_address}`,
          "complemento": "",
          "bairro": address_data.neighborhood,
          "codigo_pais": "BR",
          "cidade": address_data.city,
          "estado": address_data.state_code,
          "cep": address_data.postal_code
        },
        "lojista_detalhe": {
          "mcc": `${billing.merchant_category_code}`
        }
      }
  )
  return { method: 'POST', body: body, headers: { 'Content-Type': 'application/json', }}
}

export function formatCPF(value) {
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
}

export function formatCNPJ(value) {
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5")
}


export function recurrenceType(value) {
  switch (value) {
    case "M":
      return "Mensal"
    case "S":
      return "Semanal"
    case "Q":
      return "Quinzenal"
    default:
      return "Indefinido"
  }
}
